import React, { Fragment } from 'react';
import { array, shape, func } from 'prop-types';
import { Flex, Box } from 'grid-styled';
import FontAwesomIcon from 'react-fontawesome';
import { Popconfirm } from 'antd';
import LyraCartItem from './LyraCartItem';
import { StyledCardCart } from './StyledCardCart';

function LyraCardCart(props) {
  const { cartList, orderObj, handleChildActions } = props;
  return (
    <Fragment>
      <StyledCardCart>
        <Flex flexWrap="wrap" className="thead">
          <Box width={[4 / 12]} className="text-left padding-l-1">
            Item
          </Box>
          <Box width={[3 / 12]}>
            Amount
          </Box>
          <Box width={[4 / 12]}>
            Action
          </Box>
        </Flex>
        {cartList.map((item) => (
          <Flex flexWrap="wrap" className="td" key={item.key}>
            <Box width={[4 / 12]}>
              <LyraCartItem cart={item} {...props} />
            </Box>
            <Box width={[3 / 12]}>
              <b>Rs. {item.itemPrice}<br /></b>
            </Box>
            <Box width={[4 / 12]}>
              <Popconfirm
                title="Are you sure you want to delete this item?"
                onConfirm={() =>
                  handleChildActions('delete', item.product_variation_id, item.title)
                }
                okText="Yes"
                cancelText="No"
                okType="default"
              >
                <button
                  type="button"
                  className="delete-button"
                  title="Delete item"
                >
                  <FontAwesomIcon name="trash" title="Delete" />
                </button>
              </Popconfirm>
            </Box>
          </Flex>
        ))}
        <Flex flexWrap="wrap" className="thead">
          <Box width={[6 / 12]} className="text-right">
            &nbsp;
          </Box>
          <Box width={[6 / 12]} className="text-right">
            <span className="total">Total:<b>Rs. {orderObj.orderSummeryAmount}</b></span>
          </Box>
        </Flex>
      </StyledCardCart>
    </Fragment>
  );
}

LyraCardCart.propTypes = {
  cartList: array,
  orderObj: shape({}),
  handleChildActions: func,
};

LyraCardCart.defaultProps = {
  cartList: [],
  orderObj: {},
  handleChildActions: () => '',
};
export default LyraCardCart;



// WEBPACK FOOTER //
// client/containers/GiftCardCart/LyracardCart.js